import DocumentFormV2 from '../../erp/document-form-v2';
import { buildDocumentFormRegistry } from '../../erp/document-form-v2/registry';
import { FormDialog as ChungTuPhaiThuKhacChungTuBuTruCongNoForm } from '@/features/ban-hang/dieu-chinh-can-tru-cong-no/chung-tu-phai-thu-khac-chung-tu-bu-tru-cong-no/components';
import { FormDialog as ButToanDieuChinhGiamCongNoMuaHangForm } from '@/features/mua-hang/dieu-chinh-can-tru-cong-no/but-toan-dieu-chinh-giam-cong-no/components';
import { FormDialog as HoaDonDichVuTraLaiNhaCungCapForm } from '@/features/mua-hang/hoa-don-dieu-chinh-tra-lai/hoa-don-dich-vu-tra-lai-nha-cung-cap/components';
import { FormDialog as ButToanDieuChinhGiamCongNoForm } from '@/features/ban-hang/dieu-chinh-can-tru-cong-no/but-toan-dieu-chinh-giam-cong-no/components';
import { FormDialog as HoaDonDichVuTraLaiGiamGiaForm } from '@/features/ban-hang/hoa-don-dieu-chinh-tra-lai/hoa-don-dich-vu-tra-lai-giam-gia/components';
import { FormDialog as HoaDonDieuChinhGiaHangBanForm } from '@/features/ban-hang/hoa-don-dieu-chinh-tra-lai/hoa-don-dieu-chinh-gia-hang-ban/components';
import { FormDialog as PhieuXuatTraLaiNhaCungCapForm } from '@/features/mua-hang/hoa-don-dieu-chinh-tra-lai/phieu-xuat-tra-lai-nha-cung-cap/components';
import { HoaDonMuaHangTrongNuocSearchProvider } from '@/features/mua-hang/hoa-don-mua-vao/hoa-don-mua-hang-trong-nuoc/context/search-context';
import { PhieuXuatTraLaiNhaCungCapProvider } from '@/features/mua-hang/hoa-don-dieu-chinh-tra-lai/phieu-xuat-tra-lai-nha-cung-cap/context';
import { DocumentEntry } from '@/features/mua-hang/hoa-don-mua-vao/hoa-don-mua-hang-trong-nuoc/components';
import { FormDialog as PhieuNhapChiPhiMuaHangForm } from '@/features/mua-hang/hoa-don-mua-vao/phieu-nhap-chi-phi-mua-hang/components';
import { FormDialog as PhieuKeToanTheoNghiepVuForm } from '@/features/tong-hop/hach-toan/phieu-ke-toan-theo-nghiep-vu/components';
import PhieuThanhToanTamUngForm from '@/features/mua-hang/thanh-toan-tam-ung/phieu-thanh-toan-tam-ung/components/form-dialog';
import { FormDialog as HoaDonMuaDichVuForm } from '@/features/mua-hang/hoa-don-mua-vao/hoa-don-mua-dich-vu/components';
import { FormDialog as HoaDonDichVuForm } from '@/features/ban-hang/hoa-don-ban-ra/hoa-don-ban-dich-vu/components';
import { FormDialog as HoaDonBanHangForm } from '@/features/ban-hang/hoa-don-ban-ra/hoa-don-ban-hang/components';
import { HoaDonBanHangSearchProvider } from '@/features/ban-hang/hoa-don-ban-ra/hoa-don-ban-hang/context/index';
import { HoaDonMuaDichVuSearchProvider } from '@/features/mua-hang/hoa-don-mua-vao/hoa-don-mua-dich-vu/context';
import { HoaDonBanDichVuSearchProvider } from '@/features/ban-hang/hoa-don-ban-ra/hoa-don-ban-dich-vu/context';
import { FormDialog as PhieuNhapDieuChuyenForm } from '@/features/ton-kho/phieu-nhap-dieu-chuyen/components';
import { FormDialog as PhieuXuatDieuChuyenForm } from '@/features/ton-kho/phieu-xuat-dieu-chuyen/components';
import { FormDialog as ButToanHuyForm } from '@/features/tong-hop/but-toan-cuoi-ky/but-toan-huy/components';
import { FormDialog as PhieuKeToanForm } from '@/features/tong-hop/hach-toan/phieu-ke-toan/components';
import { FormDialog as GiayBaoNoForm } from '@/features/tien-gui/hach-toan/giay-bao-no/components';
import { AddForm as GiayBaoCoForm } from '@/features/tien-gui/hach-toan/giay-bao-co/components';
import { FormDialog as PhieuChiForm } from '@/features/tien-mat/hach-toan/phieu-chi/components';
import { FormDialog as PhieuNhapKhoForm } from '@/features/ton-kho/phieu-nhap-kho/components';
import { FormDialog as PhieuXuatKhoForm } from '@/features/ton-kho/phieu-xuat-kho/components';
import { GiayBaoNoSearchProvider } from '@/features/tien-gui/hach-toan/giay-bao-no/context';
import { PhieuThuForm } from '@/features/tien-mat/hach-toan/phieu-thu/components';
import { PhieuNhapKhoProvider } from '@/features/ton-kho/phieu-nhap-kho/context';
import { PhieuXuatKhoProvider } from '@/features/ton-kho/phieu-xuat-kho/context';
import QUERY_KEYS from '@/constants/query-keys';
import { FormDialog as PhieuNhapDieuChinhGiaHangMuaForm } from '@/features/mua-hang/hoa-don-dieu-chinh-tra-lai/phieu-nhap-dieu-chinh-gia-hang-mua/components';
import { default as ChungTuPhaiTraKhacChungTuBuTruCongNoForm } from '@/features/mua-hang/dieu-chinh-can-tru-cong-no/chung-tu-bu-tru-cong-no/components/form-dialog';
import { FormDialog as PhieuNhapHangBanTraLaiForm } from '@/features/ban-hang/hoa-don-dieu-chinh-tra-lai/phieu-nhap-hang-ban-tra-lai/components';

export type DocumentFormConfig = {
  FormComponent: React.ComponentType<any>;
  /**
   * Optional Provider to wrap around the FormComponent.
   * If not provided, the form will be rendered without extra context.
   */
  Provider?: React.ComponentType<{ children: React.ReactNode }>;
  controller?: 'default' | 'external';
};

export interface DocumentFormProps {
  document_uuid: string;
  document_type: string;
  onClose: () => void;
  onSubmit?: (data: any) => void;
}

/**
 * Mặc định: tập hợp FormComponent cho các document_type (model key) đã dùng trong hệ thống.
 * Provider chưa được gán (sẽ là Fragment); nếu cần context riêng, override bằng configs truyền vào.
 */
export const DEFAULT_DOCUMENT_FORM_CONFIGS: Record<string, DocumentFormConfig> = {
  // Bán hàng
  HOA_DON_BAN_HANG: { FormComponent: HoaDonBanHangForm, Provider: HoaDonBanHangSearchProvider },
  HOA_DON_BAN_HANG_IPOS: { FormComponent: HoaDonBanHangForm, Provider: HoaDonBanHangSearchProvider },
  HOA_DON_BAN_DICH_VU: { FormComponent: HoaDonDichVuForm, Provider: HoaDonBanDichVuSearchProvider },
  PHIEU_NHAP_HANG_BAN_TRA_LAI: { FormComponent: PhieuNhapHangBanTraLaiForm },
  HOA_DON_DICH_VU_TRA_LAI_GIAM_GIA: { FormComponent: HoaDonDichVuTraLaiGiamGiaForm },
  HOA_DON_DIEU_CHINH_GIA_HANG_BAN: { FormComponent: HoaDonDieuChinhGiaHangBanForm },
  CHUNG_TU_PHAI_THU_KHAC_CHUNG_TU_BU_TRU_CONG_NO: {
    FormComponent: ChungTuPhaiThuKhacChungTuBuTruCongNoForm
  },
  BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO: { FormComponent: ButToanDieuChinhGiamCongNoForm },

  // Mua hàng
  HOA_DON_MUA_HANG_TRONG_NUOC: {
    FormComponent: DocumentEntry,
    Provider: HoaDonMuaHangTrongNuocSearchProvider,
    controller: 'external'
  },
  HOA_DON_MUA_DICH_VU: { FormComponent: HoaDonMuaDichVuForm, Provider: HoaDonMuaDichVuSearchProvider },
  PHIEU_NHAP_CHI_PHI_MUA_HANG: { FormComponent: PhieuNhapChiPhiMuaHangForm },
  PHIEU_THANH_TOAN_TAM_UNG: { FormComponent: PhieuThanhToanTamUngForm },
  PHIEU_NHAP_DIEU_CHINH_GIA_HANG_MUA: { FormComponent: PhieuNhapDieuChinhGiaHangMuaForm },
  HOA_DON_DICH_VU_TRA_LAI_NHA_CUNG_CAP: { FormComponent: HoaDonDichVuTraLaiNhaCungCapForm },
  PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP: {
    FormComponent: PhieuXuatTraLaiNhaCungCapForm,
    Provider: PhieuXuatTraLaiNhaCungCapProvider
  },
  CHUNG_TU_PHAI_TRA_KHAC: { FormComponent: ChungTuPhaiTraKhacChungTuBuTruCongNoForm },
  BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO_MH: { FormComponent: ButToanDieuChinhGiamCongNoMuaHangForm },

  // Tồn kho
  PHIEU_NHAP_KHO: { FormComponent: PhieuNhapKhoForm, Provider: PhieuNhapKhoProvider },
  PHIEU_XUAT_KHO: { FormComponent: PhieuXuatKhoForm, Provider: PhieuXuatKhoProvider },
  PHIEU_NHAP_DIEU_CHUYEN: { FormComponent: PhieuNhapDieuChuyenForm },
  PHIEU_XUAT_DIEU_CHUYEN: { FormComponent: PhieuXuatDieuChuyenForm },

  // Tiền mặt / Tiền gửi
  PHIEU_CHI: { FormComponent: PhieuChiForm },
  PHIEU_THU: { FormComponent: PhieuThuForm },
  GIAY_BAO_NO: { FormComponent: GiayBaoNoForm, Provider: GiayBaoNoSearchProvider },
  GIAY_BAO_CO: { FormComponent: GiayBaoCoForm },

  // Tổng hợp
  PHIEU_KE_TOAN: { FormComponent: PhieuKeToanForm },
  PHIEU_KE_TOAN_THEO_NGHIEP_VU: { FormComponent: PhieuKeToanTheoNghiepVuForm },
  BUT_TOAN_KET_CHUYEN: { FormComponent: GiayBaoCoForm },
  BUT_TOAN_HUY: { FormComponent: ButToanHuyForm }
};

const DEFAULT_DOCUMENT_FORM_REGISTRY = buildDocumentFormRegistry(
  Object.entries(DEFAULT_DOCUMENT_FORM_CONFIGS).map(([key, config]) => ({
    keys: key,
    entry: {
      endpoint: QUERY_KEYS[key as keyof typeof QUERY_KEYS],
      ...config
    }
  }))
);

/**
 * DocumentForm
 *
 * Component generic để mở form chi tiết chứng từ dựa trên:
 *  - document_uuid
 *  - document_type (model key)
 *  - DOCUMENT_TYPES (map sang endpoint)
 *  - configs (map sang FormComponent + optional Provider)
 *
 * Cách dùng (ví dụ):
 *
 * const CONFIGS: Record<string, DocumentFormConfig> = {
 *   HoaDonBanHangModel: { FormComponent: HoaDonBanHangForm, Provider: HoaDonBanHangSearchProvider },
 *   HoaDonMuaHangTrongNuocModel: { FormComponent: HoaDonMuaHangTrongNuocForm },
 *   // ...
 * };
 *
 * <DocumentForm
 *   document_uuid={row.document_uuid}
 *   document_type={row.document_type}
 *   onClose={handleClose}
 *   configs={CONFIGS}
 * />
 */
export function DocumentForm({ document_uuid, document_type, onClose, onSubmit }: DocumentFormProps) {
  return (
    <DocumentFormV2
      document_uuid={document_uuid}
      document_type={document_type}
      onClose={onClose}
      onSubmit={onSubmit}
      registry={DEFAULT_DOCUMENT_FORM_REGISTRY}
    />
  );
}

export default DocumentForm;
